module.exports = {
      id: "whatsapp-icon-usage",
      viewBox: "0 0 24.99 25.091",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#whatsapp-icon",
      toString: function () {
        return this.url;
      }
    }